<template>
    <v-container fill-height id="walkin" v-if="!isLoading" class="py-0 py-sm-0">
        <v-row>
            <v-col>
                <v-stepper v-model="currentStep" alt-labels style="width: 100%; box-shadow: none; background: transparent;">
                    <v-stepper-items style="border: none; box-shadow: none;">
                        <v-stepper-content step="1">
                            <pet-demographic v-if="isAnimalFacility"></pet-demographic>
                            <ezyvet-owner-contact v-else-if="isEzyvetFacility"></ezyvet-owner-contact>
                            <demographic v-else></demographic>
                        </v-stepper-content>
                        <v-stepper-content step="2" v-if="secondStep">
                            <demographic v-if="secondStep === 'patientDemographics' || secondStep === 'ezyvetOwnerInfo'"></demographic>
                            <chief-complaint v-else-if="secondStep === 'chiefComplaint' || secondStep === 'clientDepartments'"></chief-complaint>
                            <custom-questions v-else></custom-questions>
                        </v-stepper-content>
                        <v-stepper-content step="3" v-if="thirdStep">
                            <chief-complaint v-if="thirdStep === 'chiefComplaint' || thirdStep === 'clientDepartments'"></chief-complaint>
                            <ezyvet-pet-info v-else-if="thirdStep === 'ezyvetPetInfo'"></ezyvet-pet-info>
                            <custom-questions v-else></custom-questions>
                        </v-stepper-content>
                        <v-stepper-content step="4" v-if="fourthStep">
                            <custom-questions></custom-questions>
                        </v-stepper-content>
                        <v-stepper-content :step="lastStep">
                            <chief-complaint v-if="isEzyvetFacility"></chief-complaint>
                            <contact-info v-else></contact-info>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import EzyvetOwnerContact from './Ezyvet_OwnerContact'
    // import EzyvetOwnerInfo from './Ezyvet_OwnerInfo'
    // import EzyvetSubmit from './Ezyvet_Submit'
    import EzyvetPetInfo from './Ezyvet_PetInfo'
    import PetDemographic from './Walkin_Pet_Demographic'
    import Demographic from './Walkin_Demographic'
    import ChiefComplaint from './Walkin_ChiefComplaint'
    import ContactInfo from './Walkin_ContactInfo'
    import CustomQuestions from './Walkin_CustomQuestions'
    import ContextualMixin from '../mixins/contextualMixin'
    import WalkinFormMixin from '../mixins/walkinFormMixin'
    import axios from 'axios'

    export default {
        name: 'Walkin',
        mixins: [ContextualMixin, WalkinFormMixin],
        created() {
            let tis = this;
            let isFirstAvailableRequestDone = this.$store.state.isFirstAvailableRequestDone;
            let isReservationSubmitted = this.$store.state.isReservationSubmitted;

            this.$store.dispatch('resetWalkinForm');
            if (!this.currentModel)
                this.$store.dispatch('fetchModel', this.clientId);
            let specialEvent = this.isSpecialEvent();
            if (specialEvent) {
                this.$store.state.messageHeadline = '';
                this.$store.state.messageContent = specialEvent;
                this.$router.push({ name: 'message', params: { clientId: this.clientId } });
                return;
            }

            if ((this.isClosedTime() || this.isPreOpenTime()) 
                && !window.location.hash.includes('UserId=')) {
                this.$store.state.messageHeadline = '';
                this.$store.state.messageContent = this.currentModel.settings.localizedContent['walkin_closed_message'];
                this.$router.push({ name: 'message', params: { clientId: this.clientId } });
                return;
            }

            if (!isFirstAvailableRequestDone && !isReservationSubmitted) {
                this.getFirstAvailableWalkinTime(this.clientId);

                window.addEventListener('message', (event) => {
                    if (event.origin !== tis.$store.state.parentOrigin)
                        return;

                    event.source.postMessage(JSON.stringify(tis.$store.state.unLockObject), event.origin);
                });
            }
        },
        mounted() {
            this.$store.state.isWalkin = true;
            this.$store.state.currentStep = 1;
        },
        methods: {
            getFirstAvailableWalkinTime(clientId) {
                let tis = this;
                tis.$store.state.isLoading = true;
                axios.get(`${tis.$store.state.settingsApi}/first_available_time/${clientId}`).then(r => {
                    let parentOrigin = '';
                    if (tis.$route.query && tis.$route.query.parentOrigin) {
                        parentOrigin = tis.$route.query.parentOrigin;
                    }

                    if (parentOrigin !== '') {
                        tis.$store.state.parentOrigin = parentOrigin;
                    }

                    if (r.data.isPatientMaxLimitExceeded === true) {
                        tis.$store.state.isPatientMaxLimitExceeded = r.data.isPatientMaxLimitExceeded;
                        this.$store.state.messageHeadline = '';
                        tis.$store.state.messageContent = tis.currentModel.settings.localizedContent['walkin_max_patient_count_message'];
                        tis.$store.state.unLockObject = { 'TimeSlotId': -1 };
                        tis.$router.push({ name: 'message', params: { clientId: clientId } });
                        return;
                    }

                    tis.$store.state.currentModel.availableTime = r.data;
                    tis.$store.state.unLockObject = {
                        'TimeSlotId': r.data.clientAvailableTimeId,
                        'LockGuid': r.data.lockGuid
                    };

                    console.log(`Lock Guid ${r.data.lockGuid} for ${r.data.actualAvailableTimeDisplay}`)
                }).catch(error => {
                    if (error.response.status === 404)
                        tis.$store.state.clientNotFound = true;
                    else if (error.response.status === 500) {
                        if (error.response.data)
                            tis.$store.state.serverError = error.response.data;
                        else
                            tis.$store.state.serverError = error.message;
                    } else
                        tis.$store.state.clientError = error.message;
                }).finally(() => tis.$store.state.isLoading = false);
                tis.$store.state.isFirstAvailableRequestDone = true;
            }
        },
        watch: {
            currentStep: function () {
                document.getElementById('walkin').scrollTop = 0;
            }
        },
        components: {
            Demographic,
            ChiefComplaint,
            ContactInfo,
            CustomQuestions,
            PetDemographic,
            EzyvetOwnerContact,
            EzyvetPetInfo,
            //EzyvetOwnerInfo,
            //EzyvetPetInfo,
            //EzyvetSubmit
        }
    }
</script>

<style>
    form label { 
        font-weight: 600;
        display: block;
    }
    .v-stepper__content { 
        padding: 0;
        min-height: 400px;
    }
    .v-list-item:not(:last-child) {
        border-bottom: solid 1px #e6e6e6;
    }
    .v-text-field__details { overflow: visible; }
    .v-text-field.v-text-field--enclosed .v-text-field__details {
        white-space: pre;
        padding: 0
    }
    .input-valid {
        position: relative !important;
        top: -70px;
        left: -40px;
    }
    .v-application .input-valid.archimedes { color: black !important; }
    .input-valid::before { 
        font-weight: bolder !important;
        font-size: 32px !important;
    }
    .form-group { max-height: 85px; }
    .v-select.v-select--chips .v-select__selections { margin-top: 4px; margin-bottom: 4px; }
    .form-group > label { margin-bottom: 5px; }
    #walkin div > label { font-size: 16px; }
    .v-application .v-btn-toggle { width: 100%; }
    .v-application .v-btn-toggle.has-2-toggles > .v-btn { width: 50%; }
    .v-application .v-btn-toggle.has-3-toggles > .v-btn { width: 33.33333333%; }
    .v-application .v-btn-toggle > .v-btn { 
        font-size: 16px;
        color: #999 !important;
    }
    .v-application .v-btn-toggle > .v-btn.v-btn--active {
        color: white !important;
        background: rgb(59,173,234) !important;
    }
    .v-btn--outlined, .v-btn--flat { background-color: rgb(253, 253, 253); }    
    .v-stepper, v-stepper div { height: 100% !important; }
    @media (max-width: 599px) {
        .form-group > label { font-size: 14px; }
        .form-group { max-height: 80px;  }
        #walkin div > label { font-size: 14px; }
        #walkin input, #walkin textarea { font-size: 14px; }
    }
</style>